import { Column } from '@ant-design/charts'
import { ColumnConfig } from '@ant-design/plots/es/components/column'
import { Flex } from 'antd'
import React, { useMemo } from 'react'

import SectionTitle from '../section-title'

export interface ChatterPerformanceFanChattedProps {
  data: { dateStr: string, name: string, count: number }[]
}

export default function ChatterPerformanceFanChatted({ data }: ChatterPerformanceFanChattedProps) {
  const config = useMemo(() => {
    const config: ColumnConfig = {
      data,
      xField: 'dateStr',
      yField: 'count',
      seriesField: 'name',
      axis: {
        x: {
          labelAutoRotate: false,
        },
      },
      height: 320,
      style: {
        maxWidth: 5,
        minHeight: 1,
        fill: '#3A5C40',
        fillOpacity: 1,
      },
    }

    return config
  }, [data])

  return (
    <Flex vertical gap={8}>
      <SectionTitle
        title="Fans chatted"
        tooltip="Total fans the Chatter has replied to"
      />
      <Column {...config} />
    </Flex>
  )

}